import React, {
    useEffect,
    useState,
    useRef,
    useContext,
    useCallback,
    Fragment,
  } from "react";
  import ReactDOM from "react-dom";
  import { useLocation, useNavigate } from "react-router-dom";
  import sanityClient from "../../client.js";
  import "./about.styles.scss";
  
  import { PortableText } from "@portabletext/react";
  import SanityMuxPlayer from "sanity-mux-player";
  import imageUrlBuilder from "@sanity/image-url";

  import ReactPlayer from 'react-player'

    import { MouseContext } from "../../context/mouse-context"

  const builder = imageUrlBuilder(sanityClient);
  
  function urlFor(source) {
    return builder.image(source);
  }
  
  const About = ({content}) => {
    const {cursorChangeHandler} = useContext(MouseContext);

    const customComponent = {      
        marks: {
          link: ({children, value}) => {
            return (
              <a
              onMouseEnter={() => cursorChangeHandler("active")}
              onMouseLeave={() => cursorChangeHandler("")}
              href={value.href} target={'_blank'} >
                {children}
              </a>
            )
          },
        },
      }


    if(!content) return<></>
    return (
      <div className={"about-wrapper"}>
        <div className="about-grid">
        <div className="about-left">
          <img src={urlFor(content[0].image).width(Math.round(window.innerWidth / 2)).url()}/>
        </div>
        <div className="about-right">
          <div className="section">
            <div className="section-title title-font">About</div>
                <PortableText
                  value={content[0].about}
                  components={customComponent}
                />
            </div>
            <div className="section">
              <div className="section-title title-font">Awards</div>
                <PortableText
                  value={content[0].awards}
                  // components={/* optional object of custom components to use */}
                />
            </div>
          </div>
          </div>
      </div>
    );
  };
  
  export default About;
  